import { Response } from "@interfaces/response";
import { baseApi } from "./baseApi";
import { PortalUser } from "@interfaces/portalUsers";

const portalUserApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPortalUsers: build.query<PortalUser, string>({
            query: (userId) => ({
                url: `usuarios_portal/${userId}`,
            }),
            transformResponse: (response: Response<PortalUser>) => {
                return response.data;
            },
        }),
    }),
});

export const { useLazyGetPortalUsersQuery } = portalUserApi;
